<template>
  <div class="control_list" v-if="controlList">
    <!-- v-perm="control.perm"  :不受权限控制 -->
    <div
      v-for="(control, index) in controlList"
      :key="index"
      :class="['control', !control.disabled && 'classType']"
      @click="chooseControl(control, index)"
    >
      <div
        :class="[
          'control_btton',
          chooseControls == index && 'current',
          !control.disabled && 'classType',
        ]"
      >
        <img :src="control.icon" />
      </div>
      <div :class="['control_name']">
        {{ control.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      classType: true,
    };
  },
  props: {
    equip_data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    router_equip_data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    topIndex: {
      type: Array,
      default: () => {
        return [];
      },
    },
    chooseControls: {
      type: Number,
      default: 1,
    },
    onlineShop: {
      type: Boolean,
      default: false,
    },
    /*是否有IOT数据 */
    isShowEcharts: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    },
    controlList() {
      let control_420 =
        this.equip_data.product_type == "1"
          ? (this.isPaperMaking ? [
            {
              name: this.$t("all_device"),
              icon: require("@/assets/settings.svg"),
              disabled: true,
              perm: "dashboard.overview",
              target: "_self",
              routeName:
                "/fullIndex?path=4&id=" + this.equip_data.customer_id,
            },
            {
              name: this.$t("digital_twin"),
              icon: require("@/assets/数字孪生.svg"),
              disabled: true,
              perm: "dashboard.overview",
              target: "_self",
              routeName: "VSD420-OverAll",
            },
            {
              name: this.$t("expert_view"),
              icon: require("@/assets/control1.svg"),
              perm: "dashboard.overview",
              disabled: true,
              target: "_self",
              routeName: "health-monitor",
            },
            {
              name: this.$t("device_lifecycle"),
              icon: require("@/assets/control4.svg"),
              perm: "dashboard.overview",

              disabled: true,
              target: "_self",
              routeName: "equipment-detail",
            },
            {
              name: this.$t("online_store"),
              icon: require("@/assets/control5.svg"),
              perm: "dashboard.overview",
              disabled: true,
              target: "_self",
              routeName: "Online Shop",
            },
          ]
            :
            [
              {
                name: this.$t("all_device"),
                icon: require("@/assets/settings.svg"),
                disabled: true,
                perm: "dashboard.overview",
                target: "_self",
                routeName:
                  "/fullIndex?path=4&id=" + this.equip_data.customer_id,
              },
              {
                name: this.$t("digital_twin"),
                icon: require("@/assets/数字孪生.svg"),
                disabled: true,
                perm: "dashboard.overview",
                target: "_self",
                routeName: "VSD420-OverAll",
              },
              {
                name: this.$t("expert_view"),
                icon: require("@/assets/control1.svg"),
                perm: "dashboard.overview",
                disabled: true,
                target: "_self",
                routeName: "health-monitor",
              },
              // { 
              //   name: this.$t("Intelligent Diagnosis"),
              //   icon: require("@/assets/control-gzyc.svg"),
              //   perm: "dashboard.overview",
              //   disabled: true,
              //   target: "_self",
              //   routeName: "VSD420-Fault",
              // },
              {
                name: this.$t("audit_report"),
                icon: require("@/assets/control2.svg"),
                perm: "dashboard.overview",
                disabled: true,
                target: "_self",
                routeName: "auditReport",
              },
              // 节能降碳
              {
                name: this.$t("energy_analysis"),
                icon: require("@/assets/control3.svg"),
                perm: "device.get",
                disabled: true,
                target: "_self",
                routeName: "EnergyConsumption706",
              },
              {
                name: this.$t("device_lifecycle"),
                icon: require("@/assets/control4.svg"),
                perm: "dashboard.overview",

                disabled: true,
                target: "_self",
                routeName: "equipment-detail",
              },
              {
                name: this.$t("online_store"),
                icon: require("@/assets/control5.svg"),
                perm: "dashboard.overview",

                disabled: true,
                target: "_self",
                routeName: "Online Shop",
              },
            ]
          )
          : [
            {
              name: this.$t("all_device"),
              icon: require("@/assets/settings.svg"),
              disabled: true,
              perm: "dashboard.overview",
              target: "_self",
              routeName:
                "/fullIndex?path=4&id=" + this.equip_data.customer_id,
            },
            {
              name: this.$t("digital_twin"),
              icon: require("@/assets/数字孪生.svg"),
              disabled: true,
              perm: "dashboard.overview",
              target: "_self",
              routeName: "VSD420-OverAll",
            },
            {
              name: this.$t("Intelligent Diagnosis"),
              icon: require("@/assets/control-gzyc.svg"),
              perm: "dashboard.overview",
              disabled: true,
              target: "_self",
              routeName: "VSD420-Fault",
            },
            // 节能降碳
            {
              name: this.$t("energy_analysis"),
              icon: require("@/assets/control3.svg"),
              disabled: true,
              perm: "device.get",
              target: "_self",
              routeName: "EnergyConsumption706",
            },
          ];


      return control_420;
    },
  },
  methods: {
    chooseControl(control, index) {
      if (control.disabled) {
        if (control.target == "_self" && index != this.chooseControls) {
          if (control.routeName == "Online Shop") {
            window.open("https://nashchina.1688.com", "_blank");
          } else if (control.name == this.$t("all_device")) {
            this.$router.push(control.routeName);
          } else {
            if (control.routeName === "equipment-detail") {
              this.$router.push({
                name: control.routeName,
                query: {
                  index: this.$route.query.index || 1,
                  equip_id: this.router_equip_data.id,
                  type: "fullLifecycle",
                  sub_id: this.equip_data.id,
                },
              });
            } else if (control.routeName === "auditReport") {
              this.$router.push({
                name: "equipment-detail",
                query: {
                  index: this.$route.query.index || 1,
                  equip_id: this.router_equip_data.id,
                  type: "examinationReport",
                  sub_id: this.equip_data.id,
                },
              });
            } else if (control.routeName === "EnergyConsumption706") {
              const data = this.$store.state.equipManagement.equipData
              //节能降碳
              if (this.router_equip_data.id === this.equip_data.id) {
                this.$router.push({
                  name: "equipment-detail",
                  query: {
                    index: this.$route.query.index || 1,
                    equip_id: this.router_equip_data.id,
                    type: "energyConsumptionAnalysis",
                    isShowEcharts: this.isShowEcharts,
                  },
                });
              } else  {
                console.log(this.router_equip_data,"this.router_equip_data.id");
                
                this.$router.push({
                  name: "equipment-detail",
                  query: {
                    index: this.$route.query.index || 1,
                    equip_id: this.isPaperMaking?data.id : this.router_equip_data.id,
                    type: "energyConsumptionAnalysis",
                    isShowEcharts: this.isShowEcharts,
                    sub_id: this.equip_data.id,
                  },
                });
              }

            } else {
              if (control.routeName === "VSD420-Fault") {
                //智能诊断页面
                this.$router.push({
                  name: control.routeName,
                  query: {
                    index: this.$route.query.index || 1,
                    top_index: JSON.stringify(this.topIndex),
                    equip_id: this.equip_data.id,
                  },
                });
              }else if(control.routeName === "VSD420-OverAll"){
                this.$router.push({
                  name: control.routeName,
                  query: {
                    index: this.$route.query.index || 1,
                    equip_id: this.router_equip_data.id,
                    sub_id: this.equip_data.id,
                  },
                });
              } else if(control.routeName === "health-monitor"){ //专家视角
                this.$router.push({
                  name: control.routeName,
                  query: {
                    index: this.$route.query.index || 1,
                    equip_id: this.router_equip_data.id,
                    sub_id: this.equip_data.id,
                  },
                });
              } else {
                this.$router.push({
                  name: control.routeName,
                  query: {
                    index: this.$route.query.index || 1,
                    equip_id: this.equip_data.id,
                  },
                });
              }
            }
          }
        }
        if (control.target == "_blank") {
          let routeData = this.$router.resolve({
            name: control.routeName,
            query: { index: this.$route.query.index || 1 },
          });
          window.open(routeData.href, "_blank");
        }
      }
    },
  },
  components: {},
  mounted() {
    if (this.$route.name.includes("VSD420-")) {
      this.classType = false;
    } else {
      this.classType = true;
    }
  },
};
</script>

<style scoped lang="scss">
.control_list {
  width: 50%;
  display: flex;
  align-items: flex-start;
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2008; //比智能运维模式弹框（z-idenx:2010px）,低2层。遮罩层
  font-size: 18px;
  .control {
    flex: 1;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
  }

  .control_btton {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    padding: 8px;
    background: #000;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    img {
      width: 50%;
      height: 50%;
      filter: drop-shadow(rgba(255, 255, 255, 0.5) 0px 0);
    }

    &.current {
      width: 110px;
      height: 110px;
      border: 4px solid #fff;
      background: transparent;
      img {
        filter: drop-shadow(#fff 0px 0);
      }
    }

    &:hover {
      cursor: pointer;
    }
  }
}
.classType {
  color: #cccccc !important;
  cursor: not-allowed !important;
}
.iconDisplay {
  display: none !important;
}
.control_name {
  text-align: center;
}
</style>
